import { render, staticRenderFns } from "./_ListaConsulta.vue?vue&type=template&id=1af072ac&"
import script from "./_ListaConsulta.vue?vue&type=script&lang=js&"
export * from "./_ListaConsulta.vue?vue&type=script&lang=js&"
import style0 from "./_ListaConsulta.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports